import store from '@/store';
import i18n from '@/js/i18n';

const state = {
  locale: i18n.locale,
  listeMessages: [],
  messagesFlash: [],
};

// TODO: getters triviaux https://dev.to/timothyokooboh/vuex-best-practices-45dd (point E)
const getters = {
  getListeMessages: (state) => {
    if (i18n.locale != state.locale) {
      store.commit('message/SET_LOCALE', i18n.locale);
      store.commit('message/SET_LISTE_MESSAGES', []);
    }
    return state.listeMessages;
  },
  getMessagesFlash: (state) => {
    return state.messagesFlash;
  },
};

const mutations = {
  SET_LOCALE(state, value) {
    state.locale = value;
  },
  SET_LISTE_MESSAGES(state, value) {
    state.listeMessages = value;
  },
  ADD_MESSAGE(state, value) {
    state.listeMessages.push(value);
  },
  SET_MESSAGE(state, args) {
    state.listeMessages[args.index] = args.message;
  },
  RESET_LISTE_MESSAGES(state) {
    state.listeMessages = [];
  },

  ADD_MESSAGE_FLASH(state, value) {
    state.messagesFlash.push(value);
  },
  RESET_LISTE_MESSAGES_FLASH(state) {
    state.messagesFlash = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
